<ng-container *ngIf="hero">
    <div class="page-content fw bg-hero pb--48">
        <div class="intro pt--64  pb--64 container">
            <div class="intro ">
                <div class="row">
                    <div class="col-12 col-md-7 col-lg-7 mt--8 mb--8 column align-items-start justify-content-center">
                        <h1 class="page-title-responsive pb--16" [innerHTML]="hero.title | translate"></h1>
                        <div class="h3" [innerHTML]="hero.content | translate"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
<div id="discoverFeatures" class="container-fluid pb--48">
    <promo-features/>
</div>

<!-- plans -->
<div id="plans" class="container-expanded pt--64 pb--64 bg-sky" *ngIf="reportPlans">
    <div class="container pt--48">
        <h1 class="section-title text-center col col-lg-8 offset-lg-2" [innerHTML]="'page.report.section_plans_title' | translate"></h1>
        <div class="mat-subtitle-2 col-lg-8 offset-lg-2 text-center" [innerHTML]="'page.report.section_plans' | translate" ></div>
        <div class="pt--48 pb--48 box-plans grid gap-16" *ngIf="reportPlans" [ngClass]="'grid-cols-' + reportPlans.length">
            <mat-card class="box " *ngFor="let reportBundle of reportPlans">
                <mat-card-header>
                    <mat-card-title *ngIf="reportBundle.name"><h2 class="mb--0">{{ reportBundle.name}}</h2></mat-card-title>
                </mat-card-header>    
                <mat-card-content class="p--16 flex-1 d-flex column">
                    <div class="feature-description mb--24 flex-1" *ngIf="reportBundle.description" [innerHTML]="reportBundle.description"></div>

                    <!-- <ng-container *ngIf="reportBundle.features">
                        <div class="mat-subtitle-1" *ngFor="let feature of reportBundle.features; let last=last" [innerHTML]="feature"  ></div>
                    </ng-container> -->
                    <ng-container *ngIf="reportBundle.price && reportBundle.price > 0; else askInfo">
                    <div class="mat-h1">
                        {{ reportBundle.reports}} Benchmark
                    </div>
                    <div *ngIf="reportBundle.price" class="mat-subtitle-1 mb--0" >Al costo di <b>{{ reportBundle.price | currency:'EUR':'symbol':'1.0-0'}}</b>&nbsp;<span class="fs-14 vat-hint">{{ 'VAT excluded' | translate}}</span></div>
                    <span *ngIf="reportBundle.reports && reportBundle.reports > 1" class="text-muted" >{{ reportBundle.price / reportBundle.reports }}€ x {{ reportBundle.reports }}</span>
                   <ng-container *ngIf="reportBundle.discount && reportBundle.discount > 0">
                        <div class="text-muted">{{ 'Sconto' | translate}} {{ reportBundle.discount | percent }}, {{ 'risparmi' | translate }} {{ reportBundle.save | currency:'EUR':'symbol':'1.0-0'}} </div>
                   </ng-container>
                    
                    </ng-container>
                    <ng-template #askInfo>
                        <div class="mat-h2 mb--48">{{ 'page.report.plan_ask' | translate }}</div>
                    </ng-template>
                </mat-card-content>
                <mat-card-actions class="mt--8">
                    <ng-container *ngIf="reportBundle.price && reportBundle.price > 0; else askInfoAction">
                    <button class="fw pt--24 pb--24" mat-flat-button color="primary" (click)="buyPlan(reportBundle)"><span translate class="fs-20">Acquista ora</span></button>
                    </ng-container>
                    <ng-template #askInfoAction>
                    <!-- <button class="fw pt--24 pb--24" mat-flat-button color="primary" (click)="quotePlan(reportBundle)"><span translate>Contattaci</span></button> -->
                    <div class="fw">
                        <app-component-identity-report [company]="companyEureso" [piva]="companyPiva" [buttononly]="true" [buttonlabel]="'Contattaci'" [buttonfw]="true" [buttonclass]="'fs-20'"></app-component-identity-report>
                    </div>
                    </ng-template>
                  </mat-card-actions>
            </mat-card>
        </div>
    </div>
</div>


<div class="container-fluid bg-hero pt--lg-72 pb--lg-72 p--24" id="contactReport" >
    <div class="container d-flex flex-column justify-content-center align-items-center p--lg-96 p--16 text-center gap-24">
        <div class="fs-24">Vuoi sapere ancora di più?</div>
        <div class="fs-48 mb--48">Contatta adesso un consulente specializzato e scopri i vantaggi per la tua azienda</div>
        <app-component-identity-report [company]="companyEureso" [piva]="companyPiva" [buttononly]="true" [buttonlabel]="'Scrivi subito in chat'" [buttonclass]="'fs-20 p--16'"></app-component-identity-report>
        <!-- <button mat-stroked-button color="white" (click)="quotePlan()"><span class="fs-18">Scrivi subito in chat</span></button> -->
    </div>
</div>
